// Map list-view UI state ↔ URL search params (spec §7 navigation: returning to the list restores
// search/group/focus). Defaults are OMITTED from the URL so plain /map stays clean; unrelated keys
// (view, source) are preserved.

export type MapListGroup = 'project' | 'people' | 'source';
const GROUPS: readonly MapListGroup[] = ['project', 'people', 'source'];

export interface MapListParams {
  search: string;
  group: MapListGroup;
  focus: string | null;
}

export function readListParams(sp: URLSearchParams): MapListParams {
  const rawGroup = sp.get('group');
  return {
    search: sp.get('search') ?? '',
    group: GROUPS.includes(rawGroup as MapListGroup) ? (rawGroup as MapListGroup) : 'project',
    focus: sp.get('focus'),
  };
}

export function writeListParams(sp: URLSearchParams, p: MapListParams): URLSearchParams {
  const next = new URLSearchParams(sp);
  if (p.search) next.set('search', p.search); else next.delete('search');
  if (p.group !== 'project') next.set('group', p.group); else next.delete('group');
  if (p.focus) next.set('focus', p.focus); else next.delete('focus');
  return next;
}
